module.exports = __webpack_public_path__ + "static/maternal-wellbeing-index-256084441c6cc5003d4e6bd2aafd5e40.jpg";